import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    template: '',
})
export abstract class AbstractBaseComponent implements OnDestroy {
    protected destroy$ = new Subject<true>();
    protected scrollToId: string = null;

    public ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    public scroll(id: string) {
        const scrollToElem =
            document.getElementById(id) || document.getElementsByName(id)[0];
        const scrolledElem = document.getElementById('sidebar-panel-body');
        const highlightClass = 'highlighted-control';

        if (scrollToElem && scrolledElem) {
            const inputElement = scrollToElem.querySelector('input');
            const textAreaElement = scrollToElem.querySelector('textarea');
            const scrollToPosition =
                scrollToElem.offsetTop - scrolledElem.offsetTop;
            scrolledElem.scrollTo({
                top: scrollToPosition,
                behavior: 'smooth',
            });
            const elements = document.querySelectorAll(`.${highlightClass}`);
            elements.forEach((element) =>
                element.classList.remove(highlightClass)
            );
            scrollToElem.classList.add(highlightClass);
            inputElement?.focus();
            textAreaElement?.focus();
        }
    }
}
